import { render, staticRenderFns } from "./EraserPanel.vue?vue&type=template&id=10f93252&"
import script from "./EraserPanel.vue?vue&type=script&lang=js&"
export * from "./EraserPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports